<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row" style="padding-bottom: 16px">
          <div class="header-left">
            <img
              src="assets/svg/opportunities-icon.svg"
              alt="oportunidades"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">Oportunidades</h1>
          </div>

          <div class="header-actions">
            <div class="dropdown-wrapper" #dropdownContainer></div>
            <div class="text-center event-item">

            </div>

            <div class="text-center event-item">
              <button
                class="btn btn-round-outline"
                (click)="cargarOportunidades()"
              >
                <img class="center-svg" src="assets/svg/reload-icon-org.svg" />
              </button>
            </div>

            <div class="text-center event-item">
              <button class="btn btn-round-outline" (click)="reabrirUltimoEditado()">
                <img class="center-svg" src="assets/svg/edit.svg" />
              </button>
            </div>

            <button
              class="action-btn outline"
              (click)="openMdlCreateOportunity()"
              *ngIf="permissionService.hasPermission('Oportunidades','Crear')"
            >
              <img
                src="assets/svg/plus-orange.svg"
                alt="Vista resumen"
                width="16"
                height="16"
              />
              Nuevo
            </button>
            <button class="action-btn primary" (click)="goOpportunitiesList()">
              <img
                src="assets/svg/stast-white.svg"
                alt="Añadir nuevo"
                width="16"
                height="16"
              />
              Vista de lista
            </button>
          </div>

          <div class="open-tab-title" style="padding-top: 3px">
            <div style="padding-top: 3px">
              <div class="d-grid general-title">
                <div>
                  <h2 class="text-semibold">Vista General</h2>
                </div>
                <div class="d-grid filter-opportunities">
                  <div class="d-grid filter-opp">
                    <div>Fecha de cierre</div>
                    <select
                      class="crm-input"
                      [(ngModel)]="filtros.fecha"
                      (change)="filtrarOportunidades()"
                    >
                      <option value="">Selecciona</option>
                      <option value="semana">Esta semana</option>
                      <option value="mes">Este mes</option>
                      <option value="trimestre">Este trimestre</option>
                      <option value="semana_siguiente">Semana siguiente</option>
                      <option value="mes_siguiente">Mes siguiente</option>
                      <option value="trimestre_siguiente">
                        Siguiente trimestre
                      </option>
                    </select>
                  </div>

                  <div class="d-grid filter-opp">
                    <div>Propietario</div>
                    <select
                      class="crm-input"
                      [(ngModel)]="filtros.propietario"
                      (change)="filtrarOportunidades()"
                    >
                      <option value="">Selecciona</option>
                      <option
                        *ngIf="currentUserRole.toLowerCase() === 'ejecutivo'"
                        value="mio"
                      >
                        Mías
                      </option>

                      <ng-container
                        *ngIf="currentUserRole.toLowerCase() === 'admin' || currentUserRole.toLowerCase() === 'administrador'"
                      >
                        <option value="todos">Todos</option>
                        <option
                          *ngFor="let user of ejecutivos"
                          [value]="user.nombreCompleto"
                        >
                          {{ user.nombreCompleto }}
                        </option>
                      </ng-container>
                    </select>
                  </div>

                  <div class="d-grid filter-opp">
                    <div>Cambios desde</div>
                    <select
                      class="crm-input"
                      [(ngModel)]="filtros.cambios"
                      (change)="filtrarOportunidades()"
                    >
                      <option value="">Selecciona</option>
                      <option value="7">Últimos 7 días</option>
                      <option value="30">Últimos 30 días</option>
                      <option value="90">Últimos 90 días</option>
                    </select>
                  </div>
                  <div class="text-center event-item">
                    <button
                      class="btn btn-round-outline btn-mark"
                      (click)="checkMarkedOpportunities()"
                    >
                      <img
                        class="center-svg"
                        src="assets/svg/bookmark-icon.svg"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <div class="d-grid progress-status-row mt-3">
                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-1.svg"
                        class="card-icon"
                      />
                      <span class="card-title">En curso</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.enCurso | montoInteligente }}</b 
                      >
                    </div>
                  </div>
                </div>

                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-2.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Nuevas</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.nuevas | montoInteligente }}
                      </b>
                      
                    </div>
                  </div>
                </div>

                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-3.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Ganadas</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.ganadas | montoInteligente }}
                      </b>
                      
                    </div>
                  </div>
                </div>

                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-4.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Aumentadas</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.aumentadas | montoInteligente }}
                      </b>
                      
                    </div>
                  </div>
                </div>

                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-5.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Ingresadas</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.ingresadas | montoInteligente }}
                      </b>
                    
                    </div>
                  </div>
                </div>

                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-6.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Sacadas fuera</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.sacadasFuera | montoInteligente }}
                      </b>
                      
                    </div>
                  </div>
                </div>

                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-7.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Disminuidas</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.disminuidas | montoInteligente }}
                      </b>
                      
                    </div>
                  </div>
                </div>

                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-8.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Perdidas</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.perdidas | montoInteligente }}
                      </b>
                      
                    </div>
                  </div>
                </div>

                <div class="status-card-4">
                  <div class="content-card-4">
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-9.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Atrasadas</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold">
                        {{ totales.atrasadas | montoInteligente }}
                      </b>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="header-stats mt-3">
          <span
            >{{oportunidades.length}} elementos | Se actualizó hace 2
            minutos</span
          >
        </div>

        <div class="content-area mt-5">
          <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
          <div *ngIf="!isLoading && oportunidades.length > 0">
            <div class="opp-table-container mh-50">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th class="checkbox-column">
                      <img src="assets/svg/checkline-icon.svg" />
                    </th>
                    <th>Nombre de la oportunidad</th>
                    <th>
                      <div>
                        <img
                          class="center-svg"
                          src="assets/svg/marked-icon.svg"
                          alt=""
                        />
                      </div>
                    </th>
                    <th>Nombre de la cuenta</th>
                    <th>Importe</th>
                    <th>Fecha de cierre</th>
                    <th>Etapa</th>
                    <th>Siguiente paso</th>
                    <th>Actividad Reciente</th>
                    <th>Categoria de previsión</th>
                    <th>Nombre completo del propietario</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let oportunidad of oportunidades; let i = index"
                    (click)="verDetalleOportunidad(oportunidad.oportunidad_id, $event)"
                  >
                    <td class="counter-cell">{{ i + 1 }}.</td>
                    <td class="checkbox-column">
                      <input type="checkbox" />
                    </td>
                    <td>
                      {{ oportunidad.nombre?.charAt(0)?.toUpperCase() +
                      oportunidad.nombre?.slice(1) }}
                    </td>
                    <td>
                      <div
                        (click)="updateMarca(oportunidad.oportunidad_id, $event)"
                      >
                        <img
                          class="center-svg"
                          [src]="oportunidad?.marcado === 0 ? 'assets/svg/unmarked-icon.svg' : 'assets/svg/marked-icon.svg'"
                          alt=""
                        />
                      </div>
                    </td>
                    <td>
                      {{
                      oportunidad?.cuenta?.nombre_empresa?.charAt(0)?.toUpperCase()
                      + oportunidad?.cuenta?.nombre_empresa?.slice(1) }}
                    </td>
                    <td class="info-td">
                      <div class="d-grid grid-td">
                        <div *ngIf="editAmount === -1">
                          CLP {{ oportunidad.importe_actual | number: '1.0-0' }}
                        </div>
                        <input
                          (keydown.enter)="saveNewAmount(i, oportunidad?.oportunidad_id)"
                          [(ngModel)]="actualAmount"
                          *ngIf="editAmount === i"
                          type="text"
                        />
                        <div
                          class="tooltip"
                          *ngIf="editAmount === -1 && oportunidad.importe_actual < oportunidad.importe_antes"
                        >
                          <img src="assets/svg/budget-down-icon.svg" alt="" />
                          <div class="tooltip-text">
                            <div class="tooltip-header">
                              <span
                                >Importe disminuido en {{
                                (oportunidad.importe_antes -
                                oportunidad.importe_actual) | number: '1.0-0'}}
                                CLP</span
                              >
                            </div>
                            <div class="tooltip-body">
                              CLP {{oportunidad.importe_antes | number:
                              '1.0-0'}} a CLP {{oportunidad.importe_actual |
                              number: '1.0-0' }}
                              <br />
                              Cambiado por Luis Nunez, el 4 de Agosto de 2025
                            </div>
                          </div>
                        </div>
                        <button
                          (click)="editOppAmount(i, oportunidad.importe_actual, $event)"
                        >
                          <img src="assets/svg/edit.svg" alt="" />
                        </button>
                      </div>
                    </td>
                    <td>
                      {{ oportunidad.fecha_cierre_estimada | date: 'dd/MM/yyyy'
                      }}
                    </td>
                    <td>
                      {{ oportunidad.etapa?.charAt(0)?.toUpperCase() +
                      oportunidad.etapa?.slice(1) }}
                    </td>
                    <td class="edit-sgte">
                      <div class="d-grid edit-td">
                        <span *ngIf="editStep !== i"
                          >{{oportunidad.sgte_paso}}</span
                        >
                        <input
                          (keydown.enter)="saveNextStep(i, oportunidad?.oportunidad_id)"
                          [(ngModel)]="sgtePaso"
                          *ngIf="editStep === i"
                          type="text"
                        />
                        <button
                          (click)="editNextStep(i, oportunidad.sgte_paso, $event)"
                        >
                          <img src="assets/svg/edit.svg" alt="" />
                        </button>
                      </div>
                    </td>
                    <td>Ninguno</td>
                    <td>Confirmar</td>
                    <td>
                      {{ oportunidad?.contacto?.ejecutivo?.nombre }} {{
                      oportunidad?.contacto?.ejecutivo?.apellido }}
                    </td>
                    <td class="actions-cell">
                      <div class="dropdown-container">
                        <button
                          class="dots-button"
                          (click)="toggleActionsMenu('menu-' + oportunidad.oportunidad_id); $event.stopPropagation()"
                        >
                          <svg class="dots-icon" viewBox="0 0 24 24">
                            <circle cx="12" cy="5" r="2" />
                            <circle cx="12" cy="12" r="2" />
                            <circle cx="12" cy="19" r="2" />
                          </svg>
                        </button>
                        <div
                          class="dropdown-menu"
                          [class.show]="openedMenuId === 'menu-' + oportunidad.oportunidad_id"
                        >
                          <button
                            class="dropdown-item"
                            (click)="updateOportunity(oportunidad)"
                            *ngIf="permissionService.hasPermission('Oportunidades','Modificar')"
                          >
                            Modificar
                          </button>
                          <button
                            class="dropdown-item"
                            (click)="openMdlDeleteOportunity(oportunidad.id)"
                            *ngIf="permissionService.hasPermission('Oportunidades','Eliminar')"
                          >
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            *ngIf="!isLoading && oportunidades.length === 0 && !errorMessage"
            class="empty-state"
          >
            <div class="empty-content">
              <div class="empty-image">
                <img
                  src="assets/img/listaprospecto.png"
                  alt="Lista de prospectos vacía"
                />
              </div>
              <h2>Sin oportunidades por ahora</h2>
              <p>
                Todavía no tienes oportunidades registradas. Puedes comenzar
                agregando una nueva.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
